import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Avatar, Button, Card, CardContent, Chip, Divider, Fab, FormGroup, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, TablePagination, Tooltip, Typography } from '@mui/material';
import config from 'src/config';
import LabelIcon from '@mui/icons-material/Label';
import Swal from 'sweetalert2';
import showLoading from './../common/loading';
import { deleteMultipleFiles, getFiles } from '../services/file.service';
import { useNavigate, useParams } from 'react-router-dom';
import FileCard, { fileCardInstance } from 'src/components/file-card';
import { ReactWebStore } from 'react-webstore';
import { fData } from 'src/utils/formatNumber';
import AddIcon from '@mui/icons-material/Add';
import AddLabelOrFlagModal from 'src/modals/AddLabelOrFlag.modal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import EmailIcon from '@mui/icons-material/Email';
import { getSearchSuggestions } from 'src/services/search.service';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InboxIcon from '@mui/icons-material/Inbox';
import AddEditContainerModal from './../modules/containers/AddEdit.modal';
import AddContainerModal from 'src/modals/AddContainer.modal';
import ReactMarkdown from 'react-markdown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddEditNoteModal from '../components/notes/AddEditNote.modal';
import FileUpload from 'src/components/file-upload';
import CreateOfficeFileModal from 'src/components/office/CreateOfficeFile.modal';
import containerMethods from 'src/methods/container.methods';
import TrustInfo from 'src/components/trust/TrustInfo';
import NoteCardComponent from 'src/components/notes/NoteCard.component';
// import ChatModal from 'src/components/chat/Chat.modal';
import moment from 'moment';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import constants from '../components/constants/common';
import { getProfile } from 'src/services/profile.service';
import CloseIcon from "@mui/icons-material/Close";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import BoardCardComponent from 'src/components/boards/BoardCard.component';
import ContainersListOnly from '../modules/containers/ListOnly';
import OrganizingStatus from 'src/components/files/OrganizingStatus';
import Actions from 'src/components/actions/Actions';
import Search from 'src/components/common/search';

const WordImg = require('./../assets/fileIcons/word.png');
const ExcelImg = require('./../assets/fileIcons/excel.png');
const PowerpointImg = require('./../assets/fileIcons/powerpoint.png');
const PdfImg = require('./../assets/fileIcons/pdf.png');
const ImageImg = require('./../assets/fileIcons/image.png');
const AudioImg = require('./../assets/fileIcons/audio.png');
const VideoImg = require('./../assets/fileIcons/video.png');
const ArchiveImg = require('./../assets/fileIcons/archive.png');
const CadImg = require('./../assets/fileIcons/cad.png');
const DesignImg = require('./../assets/fileIcons/design.png');
const NoteImg = require('./../assets/fileIcons/note.png');
const TextImg = require('./../assets/fileIcons/text.png');
const CodeImg = require('./../assets/fileIcons/code.png');
const FileImg = require('./../assets/fileIcons/file.png');


// ----------------------------------------------------------------------

const fileIcon = {
    'word': WordImg,
    'excel': ExcelImg,
    'powerpoint': PowerpointImg,
    'pdf': PdfImg,
    'image': ImageImg,
    'audio': AudioImg,
    'video': VideoImg,
    'archive': ArchiveImg,
    'cad': CadImg,
    'design': DesignImg,
    'note': NoteImg,
    'text': TextImg,
    'code': CodeImg,
    'file': FileImg
}
const fileExtensions = [
    { value: "pdf", icon: fileIcon.pdf, label: "PDF" },
    { value: "word", icon: fileIcon.word, label: "Word" },
    { value: "excel", icon: fileIcon.excel, label: "Excel" },
    { value: "powerpoint", icon: fileIcon.powerpoint, label: "PowerPoint" },
    { value: "image", icon: fileIcon.image, label: "Image" },
    { value: "video", icon: fileIcon.video, label: "Video" },
    { value: "text,note", icon: fileIcon.text, label: "Text" },
];

const fileTypes = [
    { value: "note", icon: fileIcon.note, label: "Note" }
]

const flags = constants.flags;
const services = constants.services;
const recentOptions = constants.recentOptions;
const fileAgeOptions = constants.fileAgeOptions;
// Debounce function
function debounce(func, wait) {
    let timeout;
    let pendingReject;
    return function (...args) {
        if (pendingReject) {
            pendingReject(new Error('Debounced call cancelled'));
            pendingReject = null;
        }

        clearTimeout(timeout);

        return new Promise((resolve, reject) => {
            pendingReject = reject;
            timeout = setTimeout(async () => {
                pendingReject = null;
                try {
                    const result = await func.apply(this, args);
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            }, wait);
        });
    };
}

class Files extends React.Component {


    constructor(props) {
        super(props);

        this.rws = new ReactWebStore();

        this.state = {

            user: {
                name: '',
                nick_name: '',
                username: ''
            },

            available_storages: [],

            files: [],
            clear_view: true,
            focus_search: false,
            vector_suggested_files: [],
            llm_answer: '',
            search: '',
            search_suggestions: [],
            mini_loading: false,
            limit: 12,
            skip: 0,
            total_files: 0,
            total_file_size: 0,
            flags: [],
            labels: [],
            containers: [],
            persons: [],
            emails: [],
            file_ids: [],
            shared_by_me: false,
            shared_with_me: false,
            labelled: false,
            unorganized: false,
            organized: false,
            recent_type: '',
            service: [],
            extension: [],
            file_type: [],
            reverse_sort: false,
            advanced_search: false,
            show_selection: false,
            selected: {
                files: [],
                total_file_size: 0
            },
            select_all: false,
            addLabelModal: false,
            addFlagModal: false,
            addContainerModal: false,
            showAddEditContainerModal: false,
            currentTime: moment().format('ddd, MMM D, YYYY, HH:mm'),
        };

        this.fetchFiles = debounce(this.fetchFiles, 100);
    }


    // promised setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    async updateStateFromURL() {
        const urlParams = new URLSearchParams(window.location.search);

        // Parse and set labels from URL
        const labelsParam = urlParams.get('labels');
        if (labelsParam) {
            try {
                const labels = JSON.parse(labelsParam);
                await this.setStateAsync({ labels });
            } catch (error) { }
        }

        // Parse and set containers from URL
        const containersParam = urlParams.get('containers');
        if (containersParam) {
            try {
                const containers = JSON.parse(containersParam);
                await this.setStateAsync({ containers });
            } catch (error) { }
        }

        // Parse and set persons from URL
        const personsParam = urlParams.get('persons');
        if (personsParam) {
            try {
                const persons = JSON.parse(personsParam);
                await this.setStateAsync({ persons });
            } catch (error) { }
        }

        // Parse and set emails from URL
        const emailsParam = urlParams.get('emails');
        if (emailsParam) {
            try {
                const emails = JSON.parse(emailsParam);
                await this.setStateAsync({ emails });
            } catch (error) { }
        }

        if (labelsParam || containersParam || personsParam || emailsParam) {
            return true;
        }

        return false;
    }

    async componentDidMount() {
        let stateUpdatedFromURL = await this.updateStateFromURL();
        if (stateUpdatedFromURL) {
            this.setState({
                clear_view: false
            })
            this.fetchFiles();
        }

        await this.fetchUserProfile();

        this.rws.subscribe('sync_files', async (e) => {
            if (this.rws.getStore(e.type) == 'success') {
                this.fetchFiles(false);
            }
        })

        // Start interval to update time
        this.timeInterval = setInterval(() => {
            this.setState({
                currentTime: moment().format('ddd, MMM D, YYYY, HH:mm')
            });
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.timeInterval);
    }

    fetchUserProfile = async () => {
        try {
            const profile = await getProfile();
            if (profile.error) {
                console.error("Error fetching profile:", profile.error);
                return;
            }

            this.setState({
                user: {
                    name: profile?.name || '',
                    nick_name: profile?.nick_name || '',
                    username: profile?.username || '',
                }
            });
        } catch (error) {
            console.error("Error fetching profile:", error.message);
        }
    }

    getQuery(all_files = false) {
        const options = {
            limit: this.state.limit,
            skip: this.state.skip
        }
        if (this.state.search)
            options.search = this.state.search;

        if (this.state.flags && this.state.flags.length > 0)
            options.flags = this.state.flags;

        if (this.state.labels && this.state.labels.length > 0)
            options.labels = this.state.labels.map(l => l.value);

        if (this.state.containers && this.state.containers.length > 0)
            options.containers = this.state.containers.map(l => l.value);

        if (this.state.containers && this.state.containers.length > 0)
            options.containers = this.state.containers.map(c => c.value);

        if (this.state.containers && this.state.containers.length > 0)
            options.containers = this.state.containers.map(c => c.value);

        if (this.state.persons && this.state.persons.length > 0)
            options.persons = this.state.persons.map(p => p.value);

        if (this.state.emails && this.state.emails.length > 0)
            options.emails = this.state.emails.map(e => e.value);

        if (this.state.recent_type)
            options.recent = this.state.recent_type;

        if (this.state.shared_by_me)
            options.shared_by_me = 'true';

        if (this.state.shared_with_me)
            options.shared_with_me = 'true';

        if (this.state.service && this.state.service.length > 0)
            options.service = this.state.service.join(',');

        if (this.state.extension && this.state.extension.length > 0)
            options.extension = this.state.extension.join(',');

        if (this.state.file_type && this.state.file_type.length > 0)
            options.type = this.state.file_type.join(',');

        if (this.state.file_ids && this.state.file_ids.length > 0)
            options.file_ids = this.state.file_ids.join(',');

        if (this.state.sort_key) {
            options.sort_key = this.state.sort_key;
        }
        if (this.state.sort_order) {
            options.sort_order = this.state.sort_order;
        }

        if (all_files) {
            delete options.limit;
            delete options.skip;
            delete options.file_ids;
        }

        return options;

    }

    // fetchSearchSuggestions = async () => {
    //     try {
    //         const options = {
    //             search: this.state.search,
    //             labels: this.state.labels.map(l => l.value),
    //             containers: this.state.containers.map(l => l.value),
    //             persons: this.state.persons.map(p => p.value),
    //             emails: this.state.emails.map(e => e.value)
    //         }
    //         const search_suggestions = await getSearchSuggestions(options);
    //         if (!search_suggestions || search_suggestions?.error) {
    //             this.setState({
    //                 search_suggestions: []
    //             });
    //             return;
    //         }

    //         this.setState({
    //             search_suggestions: search_suggestions.suggestions
    //         });
    //     } catch (error) {
    //         console.error("Error fetching search suggestions:", error.message)
    //     }
    // }

    async fetchFiles(showLoader = true, options = {}) {
        try {

            if (showLoader)
                showLoading(true);

            this.setState({
                mini_loading: true
            });


            const query = this.getQuery();
            if (options?.useAI) {
                query.useAI = true;
            }
            if (options?.useOutwardAI) {
                query.useOutwardAI = true;
            }

            const files = await getFiles(query);
            if (!files) {
                showLoading(false);
                this.setState({
                    mini_loading: false
                });
                return;
            }
            if (files.error) {

                showLoading(false);
                this.setState({
                    mini_loading: false
                });


                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: files.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                });
                return;
            }

            this.setState({
                files: files.files,
                vector_suggested_files: files.vector_suggested_files || [],
                llm_answer: files.llm_answer || '',
                total_files: files.count,
                total_file_size: files.total_size,
                mini_loading: false
            });
            showLoading(false);

            // if (!options?.useAI && !options?.useOutwardAI) {
            //     this.fetchSearchSuggestions();
            // }

        } catch (error) {
            showLoading(false);
            console.error("Error fetching files:", error.message)
        }
    }

    handleSearch = async (value, options = {}) => {
        try {
            this.setState({
                search_loading: true
            });

            await this.setStateAsync({
                clear_view: false
            })

            await this.setStateAsync({
                skip: 0,
                search: value
            })

            if (value.length > 0 && !this.state.advanced_search) {
                await this.setStateAsync({
                    recent_type: '',
                    unorganized: false
                })
            } else if (value.length === 0 && !this.state.advanced_search && (this.state.labels.length > 0 || this.state.persons.length > 0 || this.state.emails.length > 0 || this.state.containers.length)) {
                await this.setStateAsync({
                    recent_type: '',
                    unorganized: false
                })
            } else if (value.length === 0 && this.state.file_ids.length) {
                await this.setStateAsync({
                    recent_type: '',
                    unorganized: false
                })
            }
            // else if (value.length === 0 && !this.state.advanced_search) {
            //     this.handleClearSearchAndFilters();
            //     return
            // }

            await this.fetchFiles(false, options);
        } catch (error) {
            if (error?.message === 'Debounced call cancelled') {
                return;
            }
            console.error("Error handling search:", error.message);
        } finally {
            this.setState({
                search_loading: false
            });
        }
    }

    handleFlagsSearch = async () => {
        await this.setStateAsync({
            skip: 0
        })
        await this.fetchFiles(false);
    }

    handleSharedByMe = async (e) => {
        await this.setStateAsync({
            skip: 0,
            shared_by_me: e.target.checked,
            shared_with_me: false
        })
        await this.fetchFiles(false);
    }

    handleSharedWithMe = async (e) => {
        await this.setStateAsync({
            skip: 0,
            shared_with_me: e.target.checked,
            shared_by_me: false
        })
        await this.fetchFiles(false);
    }

    handleRecentType = async (type) => {
        await this.setStateAsync({
            skip: 0,
            recent_type: type,
            // age_sort: ''
        })
        await this.fetchFiles(false);
    }

    handleAgeSort = async (e, value) => {

        let sort_key;
        let sort_order;

        if (value === 'youngest_active') {
            sort_key = 'active_age';
            sort_order = 'DESC';
        } else if (value === 'oldest_active') {
            sort_key = 'active_age';
            sort_order = 'ASC';
        } else if (value === 'oldest_active,youngest_inactive') {
            sort_key = 'active_age,inactive_age';
            sort_order = 'ASC';
        }
        // else if (value === 'youngest_inactive') {
        //     sort_key = 'inactive_age,';
        //     sort_order = 'ASC';
        // } else if (value === 'oldest_inactive') {
        //     sort_key = 'inactive_age';
        //     sort_order = 'DESC';
        // }

        await this.setStateAsync({
            age_sort: value,
            skip: 0,
            // recent: false,
            // recent_type: '',
            sort_key,
            sort_order,
        })
        await this.fetchFiles(false);
    }

    handleReverseSort = async () => {
        let new_state = {};
        if (this.state.sort_order === 'ASC') {
            new_state.sort_order = 'DESC';
        } else if (this.state.sort_order === 'DESC') {
            new_state.sort_order = 'ASC';
        } else {
            new_state.sort_order = 'DESC';
        }
        await this.setStateAsync(new_state);
        await this.fetchFiles(false);
    }

    handleService = (service) => async (e) => {
        let services = this.state.service;
        if (services.includes(service)) {
            services = services.filter(s => s !== service);
        } else {
            services.push(service);
        }
        await this.setStateAsync({
            skip: 0,
            service: services
        })
        await this.fetchFiles(false);
    }

    handleFileType = (file_type) => async (e) => {
        let file_types = this.state.file_type;
        if (file_types.includes(file_type)) {
            file_types = file_types.filter(f => f !== file_type);
        } else {
            file_types.push(file_type);
        }
        await this.setStateAsync({
            skip: 0,
            file_type: file_types
        })
        await this.fetchFiles(false);
    }

    handleExtension = (file_type) => async (e) => {
        let extensions = this.state.extension;

        if (extensions.includes(file_type)) {
            extensions = extensions.filter(e => e !== file_type);
        } else {
            extensions.push(file_type);
        }

        await this.setStateAsync({
            skip: 0,
            extension: extensions
        })
        await this.fetchFiles(false);
    }

    handleClearSearchAndFilters = async (showLoader = true) => {

        // Clear URL parameters
        const url = new URL(window.location);
        url.search = '';
        window.history.replaceState({}, document.title, url.toString());

        await this.setStateAsync({
            skip: 0,
            search: '',
            search_suggestions: [],
            flags: [],
            labels: [],
            containers: [],
            persons: [],
            emails: [],
            recent_type: '',
            shared_by_me: false,
            shared_with_me: false,
            service: [],
            extension: [],
            files: [],
            total_files: 0,
            total_file_size: 0,
            sort_key: '',
            sort_order: '',
            advanced_search: false,
            show_selection: false,
            selected: {
                files: [],
                total_file_size: 0
            },
            select_all: false,
            file_ids: [],
            clear_view: true,
        })
    }

    toggleShowSelectedFiles = async () => {
        if (this.state.file_ids.length > 0) {
            await this.setStateAsync({
                file_ids: []
            })
        } else {
            await this.handleClearSearchAndFilters(false);
            await this.setStateAsync({
                file_ids: this.state.selected.files || []
            })
        }
        await this.fetchFiles();
    }

    handleDeleteFiles = async () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover these files!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete them!',
            cancelButtonText: 'No, keep them',
            confirmButtonColor: 'red',
        }).then(async (result) => {

            if (!result.isConfirmed) {
                return;
            }

            let payload = {
                file_ids: this.state.selected.files
            };

            showLoading(true);

            let response = await deleteMultipleFiles(payload);
            if (response.error) {
                showLoading(false);
                console.error(response.error);
                alert('Error deleting files');
                return;
            }

            showLoading(false);

            this.fetchFiles();

            this.setState({
                selected: {
                    files: [],
                    total_file_size: 0
                },
                select_all: false,
                show_selection: false,
                file_ids: []
            });
        });
    }


    clearViewRender = () => {
        const currentHour = new Date().getHours();
        let salutation = "";

        if (currentHour < 12) {
            salutation = "Good Morning"
        } else if (currentHour < 18) {
            salutation = "Good Afternoon";
        } else {
            salutation = "Good Evening";
        }

        let name = this.state?.user?.nick_name || this.state?.user?.name || this.state?.user?.username?.split('@')[0] || "";
        if (name) {
            salutation += `, ${name}!`;
        }

        return (
            <div style={{ minHeight: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0 auto', maxWidth: '95%', }}>
                <Stack direction="column" spacing={1} sx={{ mb: 20 }}>
                    <Typography variant="body" style={{ fontSize: '1.7rem', fontVariant: 'light' }}>
                        {salutation}
                    </Typography>
                    <Typography variant="body" style={{ fontSize: '1.5rem', color: 'gray', fontVariant: 'light', marginTop: '-3px' }}>
                        Your workspace is ready.
                    </Typography>
                    <Typography variant="body" style={{ fontSize: '0.9rem', color: 'gray', fontVariant: 'light', marginTop: '-1px', opacity: '0.7' }}>
                        {this.state.currentTime}
                    </Typography>

                    <Typography variant="body2" style={
                        (this.state.organizing_status_exists || this.state.actions_exists) ? { fontWeight: 'bold', opacity: 0.7, color: 'lightgray', cursor: 'pointer', marginTop: '20px' } : { fontWeight: 'bold', opacity: 0.7, color: config.primaryColor, cursor: 'pointer', marginTop: '20px' }
                    }
                        onClick={async () => {
                            await this.setStateAsync({
                                clear_view: false,
                                recent_type: 'true'
                            });
                            this.fetchFiles();
                        }}
                    >
                        Recent
                    </Typography>

                    <Search
                        mini={true}
                        value={this.state.search}
                        onChange={(value) => {
                            this.setState({ search: value })
                            this.handleSearch(value);
                        }}
                        setFocus={(isFocused) => {
                            if (isFocused) {
                                this.setState({
                                    clear_view: false,
                                    focus_search: true
                                });
                            }
                        }}
                        loading={this.state.search_loading}
                        advanced_search={this.state.advanced_search}
                        onSearchAI={() => {
                            this.handleSearch(this.state.search, {
                                useAI: true
                            });
                        }}
                        onSearchOutwardAI={() => {
                            this.handleSearch(this.state.search, {
                                useOutwardAI: true
                            });
                        }}
                        onClearSearchAndFilters={() => {
                            this.handleClearSearchAndFilters();
                        }}
                        onToggleAdvancedSearch={() => {
                            this.setState({ advanced_search: !this.state.advanced_search });
                        }}
                    />

                    <OrganizingStatus
                        onExistsChange={async (exists) => {
                            if (exists) {
                                await this.setStateAsync({
                                    organizing_status_exists: true
                                });
                            } else {
                                await this.setStateAsync({
                                    organizing_status_exists: false
                                });
                            }
                        }}
                    />
                    
                    {/* Actions */}
                    <Actions
                        onExistsChange={async (exists) => {
                            if (exists) {
                                await this.setStateAsync({
                                    actions_exists: true
                                });
                            } else {
                                await this.setStateAsync({
                                    actions_exists: false
                                });
                            }
                        }}
                    />

                </Stack>
            </div>
        )
    }

    filesSectionRender = () => {
        return (
            <div>
                <Grid container spacing={2} >

                    {(this.state.llm_answer.length > 0) ? (
                        <Grid item xs={12}>
                            <Card sx={{ borderRadius: 1, backgroundColor: '#f0f0f0', color: '#000' }}>
                                <CardContent>
                                    <Stack direction="row" spacing={2} justifyContent={"space-between"}>
                                        <div style={{ width: '100%' }}>
                                            <ReactMarkdown
                                                children={this.state.llm_answer}
                                            />
                                        </div>
                                        <div>
                                            <IconButton
                                                onClick={async () => {
                                                    await navigator.clipboard.writeText(this.state.llm_answer);
                                                    Swal.fire({
                                                        title: 'Copied to clipboard',
                                                        icon: 'success',
                                                        showConfirmButton: false,
                                                        timer: 1500
                                                    });
                                                }}
                                                size="small"
                                            >
                                                <ContentCopyIcon />
                                            </IconButton>
                                        </div>
                                    </Stack>
                                </CardContent>
                            </Card>

                        </Grid>
                    ) : null}

                    {this.state.vector_suggested_files.map((file) => {
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={file._id}>
                                {(file.type === 'note') ? (
                                    <NoteCardComponent
                                        key={file._id}
                                        note={file}
                                        onReload={async () => {
                                            await this.fetchFiles();
                                        }}
                                    />
                                ) : null}
                                {(file.type === 'file' || file.type === 'excalidraw') ? (
                                    <FileCard
                                        key={file._id}
                                        file={file}
                                        showSelection={this.state.show_selection}
                                        selected={this.state.selected.files.includes(file._id) || this.state.select_all}
                                        onSelect={async (file) => {
                                            let selected = this.state.selected;
                                            if (selected.files.includes(file._id)) {
                                                selected.files = selected.files.filter(f => f !== file._id);
                                                selected.total_file_size -= file.size;
                                            } else {
                                                selected.files.push(file._id);
                                                selected.total_file_size += file.size;
                                            }
                                            await this.setStateAsync({
                                                selected,
                                                show_selection: true
                                            });
                                        }}
                                        onReload={async () => {
                                            await this.fetchFiles();
                                        }}
                                    />
                                ) : null}
                            </Grid>
                        );
                    })}
                </Grid>

                {/* hr */}
                {((this.state.vector_suggested_files.length > 0) || (this.state.llm_answer.length > 0)) ? (
                    <Divider sx={{ mb: 2, mt: 2 }} />
                ) : null}

                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 2, mt: 4 }}>
                    Files
                </Typography>

                {(this.state?.selected?.files?.length > 0) ? (
                    <Stack direction="row" spacing={2} justifyContent={"space-between"} sx={{ mb: 2, mt: 2 }}>
                        <Chip
                            label={`Selected Files: ${this.state.selected.files.length} | Size: ${fData(this.state.selected.total_file_size)}`}
                            onDelete={async () => {
                                await this.setStateAsync({
                                    selected: {
                                        files: [],
                                        total_file_size: 0
                                    },
                                    select_all: false,
                                    show_selection: false,
                                    file_ids: []
                                });
                            }}
                        />
                    </Stack>
                ) : null}

                {/* Bulk Actions */}
                {(this.state?.selected?.files?.length) ? (
                    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                        <Chip
                            label="Show Selected"
                            icon={<VisibilityIcon />}
                            variant={this.state.file_ids?.length ? 'filled' : 'outlined'}
                            onClick={async () => {
                                await this.toggleShowSelectedFiles();
                            }}
                            color='primary'
                            disabled={this.state.select_all}
                        />
                        <Chip
                            label="Select All"
                            icon={<DoneAllIcon />}
                            variant={this.state.select_all ? 'filled' : 'outlined'}
                            onClick={async () => {
                                this.setState({
                                    select_all: !this.state.select_all
                                });
                            }}
                            color='primary'
                            disabled={this.state.file_ids?.length}
                        />
                        <Chip
                            label="Add labels"
                            icon={<AddIcon />}
                            variant='outlined'
                            onClick={async () => {
                                this.setState({ addLabelModal: true })
                            }}
                        />
                        <Chip
                            label="Add flags"
                            icon={<AddIcon />}
                            variant='outlined'
                            onClick={async () => {
                                this.setState({ addFlagModal: true })
                            }}
                        />
                        <Chip
                            label="Add containers"
                            icon={<AddIcon />}
                            variant='outlined'
                            onClick={async () => {
                                this.setState({ addContainerModal: true })
                            }}
                        />
                        <Chip
                            label="Delete"
                            icon={<DeleteForeverIcon />}
                            variant='outlined'
                            color='error'
                            onClick={async () => {
                                this.handleDeleteFiles();
                            }}
                        />
                    </Stack>
                ) : null}

                <Grid container spacing={1}>

                    {(this.state.files.length === 0) ? (
                        <Grid item xs={12}>
                            <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', mb: 2, mt: 2, color: 'lightgray' }}>
                                No files found. Try adjusting your search or filters.
                            </Typography>
                        </Grid>
                    ) : null}

                    {this.state.files.map((file) => {
                        if (file.type === 'note') {
                            return (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={file._id}>
                                    <NoteCardComponent
                                        key={file._id}
                                        file={file}
                                        showSelection={this.state.show_selection}
                                        selected={this.state.selected.files.includes(file._id) || this.state.select_all}
                                        onSelect={async (file) => {
                                            let selected = this.state.selected;
                                            if (selected.files.includes(file._id)) {
                                                selected.files = selected.files.filter(f => f !== file._id);
                                                selected.total_file_size -= file.size;
                                            } else {
                                                selected.files.push(file._id);
                                                selected.total_file_size += file.size;
                                            }
                                            await this.setStateAsync({
                                                selected,
                                                show_selection: true
                                            });
                                        }}
                                        onReload={async () => {
                                            await this.fetchFiles();
                                        }}
                                    />
                                </Grid>
                            )
                        } else if (file.type === 'file' || file.type === 'excalidraw') {
                            return (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={file._id}>
                                    <FileCard
                                        key={file._id}
                                        file={file}
                                        showSelection={this.state.show_selection}
                                        selected={this.state.selected.files.includes(file._id) || this.state.select_all}
                                        onSelect={async (file) => {
                                            let selected = this.state.selected;
                                            if (selected.files.includes(file._id)) {
                                                selected.files = selected.files.filter(f => f !== file._id);
                                                selected.total_file_size -= file.size;
                                            } else {
                                                selected.files.push(file._id);
                                                selected.total_file_size += file.size;
                                            }
                                            await this.setStateAsync({
                                                selected,
                                                show_selection: true
                                            });
                                        }}
                                        onReload={async () => {
                                            await this.fetchFiles();
                                        }}
                                    />
                                </Grid>
                            )
                        } else if (file.type === 'board') {
                            return (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={file._id}>
                                    <BoardCardComponent
                                        key={file._id}
                                        file={file}
                                        showSelection={this.state.show_selection}
                                        selected={this.state.selected.files.includes(file._id) || this.state.select_all}
                                        onSelect={async (file) => {
                                            let selected = this.state.selected;
                                            if (selected.files.includes(file._id)) {
                                                selected.files = selected.files.filter(f => f !== file._id);
                                                selected.total_file_size -= file.size;
                                            } else {
                                                selected.files.push(file._id);
                                                selected.total_file_size += file.size;
                                            }
                                            await this.setStateAsync({
                                                selected,
                                                show_selection: true
                                            });
                                        }}
                                        onReload={async () => {
                                            await this.fetchFiles();
                                        }}
                                    />
                                </Grid>
                            )
                        }
                    })}
                </Grid>

                {(this.state.files.length > 0) ? (
                    <Stack spacing={2} sx={{ alignItems: 'center', justifyContent: "flex-end" }} direction="row">
                        {(this.state.total_files > 0) && (
                            <Typography variant="body2" color="text.disabled" component="div">
                                {`Total Files: ${this.state.total_files} | Total Size: ${fData(this.state.total_file_size)}`}
                            </Typography>
                        )}
                        <TablePagination
                            component="div"
                            count={this.state.total_files}
                            page={Math.floor(this.state.skip / this.state.limit)}
                            onPageChange={async (event, newPage) => {
                                await this.setState({ skip: newPage * this.state.limit });
                                await this.fetchFiles();
                            }}
                            rowsPerPage={this.state.limit}
                            rowsPerPageOptions={[]}
                            sx={{
                                m: 2,
                                '& .MuiTablePagination-displayedRows': { color: 'text.disabled' },
                                '& .MuiTablePagination-selectLabel': { color: 'text.disabled' },
                                '& .MuiTablePagination-select': { color: 'text.disabled' },
                            }}
                        />
                    </Stack>
                ) : null}
            </div>
        )
    }

    containersSectionRender = () => {
        return (
            <div>

                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 2, mt: 2 }}>
                    Groups
                </Typography>

                <ContainersListOnly
                    payload={{
                        type: 'container',
                        search: this.state.search,
                        recent_type: this.state.recent_type,
                        sort_key: this.state.sort_key,
                        sort_order: this.state.sort_order,
                        shared_by_me: this.state.shared_by_me,
                        shared_with_me: this.state.shared_with_me,
                        containers: this.state.containers.map(c => c.value),
                    }}
                    onContainerClick={async (container) => {
                        // console.log("Group clicked:", container);
                        let containers = this.state.containers;
                        containers.push({ value: container._id, label: container.name });
                        // // delete duplicates based on value
                        containers = containers.filter((v, i, a) => a.findIndex(t => t.value === v.value) === i);
                        await this.setState({ containers, search: '', skip: 0 });
                        this.fetchFiles(false);
                    }}
                />
            </div>
        )
    }

    render() {
        const pageBottomSpacing = this.state.clear_view ? 0 : 12;

        return (
            <>
                <Helmet>
                    <title> Files | {config.APP_NAME} </title>
                </Helmet>

                <Grid sx={(!this.state.clear_view) ? { display: 'block' } : { display: 'none' }}>
                    <Search
                        value={this.state.search}
                        autoFocus={this.state.focus_search}
                        onAutoFocus={() => this.setState({ focus_search: false })}
                        onChange={(value) => {
                            this.setState({ search: value })
                            this.handleSearch(value);
                        }}
                        setFocus={(isFocused) => {
                            if (isFocused) {
                                this.setState({ clear_view: false });
                            }
                        }}
                        loading={this.state.search_loading}
                        advanced_search={this.state.advanced_search}
                        onSearchAI={() => {
                            this.handleSearch(this.state.search, {
                                useAI: true
                            });
                        }}
                        onSearchOutwardAI={() => {
                            this.handleSearch(this.state.search, {
                                useOutwardAI: true
                            });
                        }}
                        onClearSearchAndFilters={() => {
                            this.handleClearSearchAndFilters();
                        }}
                        onToggleAdvancedSearch={() => {
                            this.setState({ advanced_search: !this.state.advanced_search });
                        }}
                    />
                </Grid>

                <Stack direction="column" spacing={1} sx={{ pb: pageBottomSpacing }}>

                    {(this.state.advanced_search) && (
                        <>
                            <Grid item xs={12}>

                                <Card variant='outlined' sx={{ mt: 2 }}>
                                    <CardContent>
                                        <Stack direction="row" flexWrap="wrap" spacing={1}>

                                            <Typography variant="subtitle1" sx={{ width: '100px', color: 'gray', alignSelf: 'center' }}>
                                                Type :
                                            </Typography>

                                            {fileTypes?.map(fileType => {
                                                const selected = this.state.file_type.includes(fileType.value);
                                                return (
                                                    <Chip
                                                        key={fileType.value}
                                                        avatar={<Avatar src={fileType.icon} />}
                                                        label={fileType.label}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={this.handleFileType(fileType.value)}
                                                        onDelete={
                                                            selected
                                                                ? this.handleFileType(fileType.value)
                                                                : undefined
                                                        }
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })}

                                            {fileExtensions?.map(fileExtension => {
                                                const selected = this.state.extension.includes(fileExtension.value);
                                                return (
                                                    <Chip
                                                        key={fileExtension.value}
                                                        avatar={<Avatar src={fileExtension.icon} />}
                                                        label={fileExtension.label}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={this.handleExtension(fileExtension.value)}
                                                        onDelete={
                                                            selected
                                                                ? this.handleExtension(fileExtension.value)
                                                                : undefined
                                                        }
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })
                                            }

                                            {/* SHARED BY ME */}
                                            <Chip
                                                label="Shared by me"
                                                variant={this.state.shared_by_me ? "contained" : "outlined"}
                                                onClick={async () => {
                                                    await this.handleSharedByMe({
                                                        target: { checked: !this.state.shared_by_me }
                                                    });
                                                }}
                                                onDelete={
                                                    this.state.shared_by_me
                                                        ? async () =>
                                                            await this.handleSharedByMe({ target: { checked: false } })
                                                        : undefined
                                                }
                                                deleteIcon={this.state.shared_by_me ? <CloseIcon /> : undefined}
                                            />

                                            {/* SHARED WITH ME */}
                                            <Chip
                                                label="Shared with me"
                                                variant={this.state.shared_with_me ? "contained" : "outlined"}
                                                onClick={async () => {
                                                    await this.handleSharedWithMe({
                                                        target: { checked: !this.state.shared_with_me }
                                                    });
                                                }}
                                                onDelete={
                                                    this.state.shared_with_me
                                                        ? async () =>
                                                            await this.handleSharedWithMe({ target: { checked: false } })
                                                        : undefined
                                                }
                                                deleteIcon={this.state.shared_with_me ? <CloseIcon /> : undefined}
                                            />

                                            {/* FLAGS (SECOND GROUP) */}
                                            {flags.map((flag, index) => {
                                                const selected = this.state.flags.includes(flag.value);
                                                return (
                                                    <Chip
                                                        key={flag?.value}
                                                        label={flag?.label}
                                                        avatar={!selected ? flag?.icon : flag?.iconSelected}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={async () => {
                                                            const newFlags = selected
                                                                ? this.state.flags.filter(f => f !== flag.value)
                                                                : [...this.state.flags, flag.value];

                                                            await this.setStateAsync({ flags: newFlags });
                                                            this.handleFlagsSearch();
                                                        }}
                                                        onDelete={
                                                            selected
                                                                ? async () => {
                                                                    await this.setStateAsync({
                                                                        flags: this.state.flags.filter(f => f !== flag.value)
                                                                    });
                                                                    this.handleFlagsSearch();
                                                                }
                                                                : undefined
                                                        }
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })}
                                        </Stack>
                                    </CardContent>

                                    <Divider />

                                    <CardContent>

                                        {/* RECENT + AGE SORT */}
                                        <Stack direction="row" flexWrap="wrap" spacing={1}>

                                            <Typography variant="subtitle1" sx={{ width: '100px', color: 'gray', alignSelf: 'center' }}>
                                                Time :
                                            </Typography>

                                            {recentOptions?.map((item) => {
                                                const selected = this.state.recent_type === item.value;
                                                return (
                                                    <Chip
                                                        key={item?.value}
                                                        label={item?.label}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={() => {
                                                            const newValue = selected ? null : item.value;
                                                            this.handleRecentType(newValue);
                                                        }}
                                                        onDelete={selected ? () => this.handleRecentType(null) : undefined}
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })}

                                            {fileAgeOptions?.map(item => {
                                                const selected = this.state.age_sort === item.value;
                                                return (
                                                    <Chip
                                                        key={item?.value}
                                                        label={item?.label}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={() =>
                                                            this.handleAgeSort(null, selected ? null : item.value)
                                                        }
                                                        onDelete={selected ? () => this.handleAgeSort(null, null) : undefined}
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })}

                                            <Chip
                                                label={"Reverse Sort"}
                                                variant={"outlined"}
                                                avatar={<SwapVertIcon />}
                                                onClick={() =>
                                                    this.handleReverseSort()
                                                }
                                            />

                                        </Stack>
                                    </CardContent>

                                    <Divider />

                                    <CardContent>

                                        {/* SERVICES */}
                                        <Stack direction="row" flexWrap="wrap" spacing={1}>

                                            <Typography variant="subtitle1" sx={{ width: '100px', color: 'gray', alignSelf: 'center' }}>
                                                Location :
                                            </Typography>

                                            {services.map((service, index) => {
                                                const selected = this.state.service.includes(service.value);
                                                return (
                                                    <Chip
                                                        key={service?.value}
                                                        avatar={<Avatar src={service?.icon} />}
                                                        label={service?.label}
                                                        variant={selected ? "contained" : "outlined"}
                                                        onClick={this.handleService(service?.value)}
                                                        onDelete={selected ? this.handleService(service.value) : undefined}
                                                        deleteIcon={selected ? <CloseIcon /> : undefined}
                                                    />
                                                );
                                            })}
                                        </Stack>

                                    </CardContent>
                                </Card>

                            </Grid>
                        </>
                    )}

                    <Grid
                        container
                        sx={{ alignItems: this.state.clear_view ? 'stretch' : 'flex-start' }}
                    >
                        <Grid item xs={12}>
                            {(this.state.clear_view) ? this.clearViewRender() : (
                                <div style={{ minHeight: 'calc(100vh - 275px)' }}>
                                    {this.filesSectionRender()}
                                    {this.containersSectionRender()}
                                </div>
                            )}
                        </Grid>
                    </Grid>

                </Stack>

                {(this.state.addLabelModal) ? (
                    <AddLabelOrFlagModal
                        open={this.state.addLabelModal}
                        mode={'label'}
                        select_all={this.state.select_all}
                        query={this.getQuery(true)}
                        total_files={this.state.total_files}
                        file_ids={this.state.selected.files}
                        onClose={() => this.setState({ addLabelModal: false })}
                        onSave={() => {
                            this.setState({ addLabelModal: false })
                            this.fetchFiles();
                        }}
                    />
                ) : null}

                {(this.state.addFlagModal) ? (
                    <AddLabelOrFlagModal
                        open={this.state.addFlagModal}
                        mode={'flag'}
                        select_all={this.state.select_all}
                        query={this.getQuery(true)}
                        total_files={this.state.total_files}
                        file_ids={this.state.selected.files}
                        onClose={() => this.setState({ addFlagModal: false })}
                        onSave={() => {
                            this.setState({ addFlagModal: false })
                            this.fetchFiles();
                        }}
                    />
                ) : null}

                {(this.state.addContainerModal) ? (
                    <AddContainerModal
                        open={this.state.addContainerModal}
                        select_all={this.state.select_all}
                        query={this.getQuery(true)}
                        total_files={this.state.total_files}
                        file_ids={this.state.selected.files}
                        onClose={() => this.setState({ addContainerModal: false })}
                        onSave={() => {
                            this.setState({ addContainerModal: false })
                            this.fetchFiles();
                        }}
                    />
                ) : null}


                {(this.state.showAddEditContainerModal) ? (
                    <AddEditContainerModal
                        open={this.state.showAddEditContainerModal}
                        onClose={() => {
                            this.setState({
                                showAddEditContainerModal: false
                            });
                        }}
                        container={null}
                        onSave={async () => {
                            await this.setStateAsync({
                                showAddEditContainerModal: false
                            });
                        }}
                    />
                ) : null}

                <TrustInfo />

                <Grid
                    container
                    sx={{
                        position: 'fixed',
                        bottom: 30,
                        zIndex: 1000,
                        right: 40,
                        justifyContent: 'flex-end',
                    }}
                >

                    <Stack direction="column" spacing={1}>

                        {(this.state.showAddEditContainerModal) ? (
                            <AddEditContainerModal
                                open={this.state.showAddEditContainerModal}
                                payload={{
                                    type: 'container'
                                }}
                                onClose={() => {
                                    this.setState({
                                        showAddEditContainerModal: false
                                    });
                                }}
                                onSave={async () => {
                                    await this.setStateAsync({
                                        showAddEditContainerModal: false
                                    });
                                }}
                            />
                        ) : null}

                        {/* <Grid item>
                            <CreateOfficeFileModal
                                onCreate={async (file) => {
                                    await this.setStateAsync({
                                        clear_view: false,
                                        recent_type: 'last_day'
                                    });
                                    this.fetchFiles(false);
                                    if (file?.file) {
                                        fileCardInstance.editFile(file.file);
                                    }
                                }}
                            />
                        </Grid> */}
                        <Grid item>
                            <div>
                                <Fab
                                    size="small"
                                    color="secondary"
                                    aria-haspopup="true"
                                    aria-expanded={Boolean(this.state.anchorEl)}
                                    onClick={(event) => this.setState({ anchorEl: event.currentTarget })}
                                >
                                    <AddIcon />
                                </Fab>
                                <Menu
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={() => this.setState({ anchorEl: null })}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                >
                                    <CreateOfficeFileModal
                                        onCreate={async (file) => {
                                            await this.setStateAsync({
                                                clear_view: false,
                                                recent_type: 'last_day'
                                            });
                                            this.fetchFiles(false);
                                            if (file?.file) {
                                                fileCardInstance.editFile(file.file);
                                            }
                                        }}
                                    />
                                    <MenuItem
                                        onClick={() => {
                                            this.setState({
                                                showAddEditContainerModal: true
                                            });
                                        }}
                                        aria-label="create container"
                                    >
                                        <ListItemIcon>
                                            <InboxIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText>Create Group</ListItemText>
                                    </MenuItem>
                                    <AddEditNoteModal
                                        add_view_type="menu_item"
                                        onCreate={async () => {
                                            this.setState({ anchorEl: null });
                                            await this.setStateAsync({
                                                clear_view: false,
                                                recent_type: 'last_day'
                                            });
                                            this.fetchFiles(false);
                                        }}
                                    />
                                </Menu>
                            </div>
                        </Grid>
                        <Grid item>
                            <FileUpload
                                onUpload={async () => {
                                    // await this.setStateAsync({
                                    //     clear_view: false,
                                    //     recent_type: 'last_day'
                                    // });
                                    // this.fetchFiles(false);
                                }}
                            />
                        </Grid>
                    </Stack>
                </Grid>


            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <Files {...props} navigate={navigate} params={params} />;
}
